import { useTranslation } from "react-i18next";

// Renders a localized slogan with its „…" quoted lead bolded. RO is the i18n fallback.
export const SloganQuote = ({ sloganKey, className = "", dark = false, testid = "slogan-quote" }) => {
  const { t } = useTranslation();
  const slogan = t(sloganKey);
  const m = slogan.match(/^(„[^”]*”)\s*(.*)$/);
  const lead = m ? m[1] : slogan;
  const rest = m ? m[2] : "";
  return (
    <blockquote className={`border-l-2 border-orange-500 pl-4 ${className}`} data-testid={testid}>
      <p className={`leading-relaxed italic ${dark ? "text-slate-300" : "text-slate-600"}`}>
        <span className={`font-bold not-italic ${dark ? "text-white" : "text-slate-900"}`}>{lead}</span>
        {rest && <> {rest}</>}
      </p>
    </blockquote>
  );
};
